<template>
  <div>
    <div v-if="canBeDownloaded">
      <b-container :style="backgroundImagePath">
        <b-row :align-h="showImgLeft ? 'between' : 'end'" class="pt-1 header">
          <b-col cols="4" v-if="showImgLeft">
            <b-img
              fluid
              :src="headerImgLeft"
              @error="handleImgErrorLeft"
              class="header-img-left"
              alt="header-img-left"
            />
          </b-col>
          <b-col cols="4" class="header-right" align-self="end">
            <b-img
              fluid
              :src="headerImgRight"
              class="header-img-right"
              alt="header-img-right"
            />
            <span class="header-img-right-caption">
              {{ headerCaption }}
            </span>
          </b-col>
        </b-row>

        <b-row class="pt-5 body">
          <b-col cols="12">
            <p>
              {{ destinationCityName }},
              {{ filingDay | moment("D [de] MMMM [del] YYYY") }}
            </p>
            <p class="pt-4">
              Señores
              <br />
              <em class="bold text-uppercase">{{ laborUnionName }}</em>
              <br />
              {{ capitalizeText(petitionerName) }}
              <br />
              <span class="bold">
                {{ petitionerRole }}
              </span>
            </p>

            <p class="pt-4">
              Ref: Respuesta permiso sindical número {{ licenseId }}
            </p>

            <p class="pt-5">Cordial saludo,</p>
            <p>
              Atendiendo su solicitud relacionada con el permiso sindical número
              {{ licenseId }} y bajo el entendido de que la Compañía reconoce y
              respeta plenamente los derechos de asociación y libertad sindical
              respaldados por la legislación Constitucional Colombiana y demás
              normas atinentes, una vez evaluada su solicitud en cumplimiento de
              los principios de necesidad, proporcionalidad y razonabilidad para
              el ejercicio de la actividad sindical,
              <strong v-if="isMessageTicketNotAvailable">
                nos complace aprobar los siguientes días de permiso, sin
                embargo, se comunica el rechazo de los tiquetes de los mismos
                por haber alcanzado el limite pactado en la Convención Colectiva
                de Trabajo:
              </strong>
              <strong v-else-if="items?.length > 0 && isAvailableTickets"
                >nos complace aprobar los siguientes días de permiso con sus
                correspondientes tiquetes:</strong
              >
              <strong v-else-if="items?.length > 0 && !isAvailableTickets"
                >nos complace aprobar los siguientes días de permiso:</strong
              >
              <strong v-else>
                nos complace aprobar los siguientes día de permiso y tiquetes rechazados:
              </strong>
            </p>
            <div
              class="pt-3"
              v-if="items?.length > 0 &&
                (isEditInclude(arrayColumn(objectEdit, 'days_approval')) ||
                include(
                  flatten(
                    licenseArrayColumn('license_employees', 'days'),
                    'status'
                  ),
                  'approved'
                ))
              "
            >
              <table-collaborator :fields="fields" :items="items" />
            </div>
            <p
              v-if="
                items?.length > 0 && isAvailableTickets && itemsDayApprovalNotTickets.length > 0
              "
            >
              También comunicamos
              <strong>
                los días que fueron aprobados y los tiquetes rechazados:</strong
              >
            </p>

            <div
              class="pt-3"
              v-if="
                isAvailableTickets && itemsDayApprovalNotTickets.length > 0
              "
            >
              <table-collaborator
                :fields="fieldsDayAprovalNotTickets"
                :items="itemsDayApprovalNotTickets"
              />
            </div>

            <div
              class="pt-3"
              v-if="
                isEditInclude(arrayColumn(objectEdit, 'days_rejected')) ||
                include(
                  flatten(
                    licenseArrayColumn('license_employees', 'days'),
                    'status'
                  ),
                  'rejected'
                )
              "
            >
              <p>
                No obstante lo anterior, comunicamos
                <strong v-if="isAvailableTickets"
                  >el rechazo de los siguientes días de permiso y
                  tiquetes:</strong
                >
                <strong v-else
                  >el rechazo de los siguientes días de permiso:</strong
                >
              </p>

              <table-collaborator :fields="fieldsDayNotAproval" :items="itemsRejected" />
            </div>

            <div
              class="pt-3"
              v-if="itemsMotiveRejected.length > 0"
            >
              <p>
                <strong>Motivos del rechazo de los días de permiso </strong>
              </p>
              <div>
                <table-collaborator
                  :fields="fieldsMotiveReject"
                  :items="itemsMotiveRejected"
                />
              </div>
            </div>
            <div
              class="pt-3"
              v-if="isAvailableTickets && itemsMotiveTicketRejected.length > 0"
            >
              <p>
                <strong>Motivos del rechazo de los tiquetes </strong>
              </p>
              <div>
                <table-collaborator
                  :fields="fieldsMotiveTicketReject"
                  :items="itemsMotiveTicketRejected"
                />
              </div>
            </div>
            <div
              class="pt-3"
              v-if="isSomeDayPending"
            >
              <p>
                Estan pendientes por gestionar los siguientes permisos:
              </p>
              <div>
                <table-collaborator
                  :fields="fields"
                  :items="itemsPendig"
                />
              </div>
            </div>

            <p class="pt-5 pb-4">
              <strong> Comentarios adicionales </strong>
              {{ isEdit ? commentsEdit : comments }}
            </p>
            <p>
              Finalmente, les agradecemos que, como se ausentarán de la Empresa
              en las fechas correspondientes, de manera previa, deben enterarse
              con sus jefes inmediatos, sobre el siguiente turno programado por
              la Compañía en el cual deberán laborar.
            </p>

            <p class="pt-4">
              Agradecemos su comprensión y colaboración en este proceso.
            </p>

            <p class="pt-4">Cordialmente,</p>

            <div class="pb-5">
              <b-img
                fluid
                :src="businessPartner.signature"
                class="signature-business-partner"
                alt="signature-business-partner"
              />
            </div>

            <p class="pt-4">
              {{ capitalizeText(businessPartner.name) }}
              <br />
              {{ businessPartner.role }}
              <br />
              {{ businessPartner.society }}
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div v-else>
      <b-alert show variant="danger">
        Esta solicitud tiene aprobaciones pendientes
      </b-alert>
    </div>
  </div>
</template>

<script>
import controller from "./controller";
const { script } = controller();
export default script;
</script>

<style lang="scss" src="./styles.scss" />
